import crawlApi, { type CrawlCountArg } from './crawlApi';

type JobPage = string | number | null | undefined;

const overviewApi = crawlApi.injectEndpoints({
  endpoints: build => ({
    getCrawlStatus: build.query<unknown, CrawlCountArg>({
      query: ({ job_page, domain_slug }: CrawlCountArg) => ({
        url: '/khazesh/v3/overview/get_crawl_status',
        method: 'POST',
        body: { job_page, domain_slug }
      })
    }),

    getCrawlInfo: build.query<unknown, CrawlCountArg>({
      query: ({ job_page, domain_slug }: CrawlCountArg) => ({
        url: '/khazesh/v3/overview/get_crawl_info',
        method: 'POST',
        body: { job_page, domain_slug }
      })
    }),

    getNumOfLinks: build.query<unknown, JobPage>({
      query: (job_page: JobPage) => ({
        url: `/khazesh/v3/overview/get_num_of_internal_external_links?job_page=${job_page}`
      })
    }),

    getPageSourceInfo: build.query<unknown, JobPage>({
      query: (job_page: JobPage) => ({
        url: `/khazesh/v3/overview/get_page_source_info?job_page=${job_page}`
      })
    }),

    getNumOfAlts: build.query<unknown, JobPage>({
      query: (job_page: JobPage) => ({
        url: `/khazesh/v3/overview/get_num_of_with_alt_and_without_alt?job_page=${job_page}`
      })
    }),

    getNumOfErrorWarningInfoes: build.query<unknown, JobPage>({
      query: (job_page: JobPage) => ({
        url: `/khazesh/v3/overview/get_num_of_errors_warnings_infoes?job_page=${job_page}`
      })
    }),

    getDepthStats: build.query<unknown, JobPage>({
      query: (job_page: JobPage) => ({
        url: `/khazesh/v3/overview/get_crawl_depth?job_page=${job_page}`
      })
    })
  })
});

export const {
  useGetCrawlInfoQuery,
  useGetNumOfAltsQuery,
  useGetNumOfLinksQuery,
  useGetNumOfErrorWarningInfoesQuery,
  useGetPageSourceInfoQuery,
  useGetDepthStatsQuery,
  useGetCrawlStatusQuery
} = overviewApi;

export default overviewApi;
